import React from "react";

export default function Home(){
    return (
        <div className="homepg">
            <div className="column">
            <a href="/date"><img className="img" src="date.jpg" alt="freelance" width="950" height="800"></img></a>
        </div>
        <div className="column">
            <div className="title">
                <h1><b>m     o     l     l     y     .      t     r     e     a     d     w     e     l     l</b></h1>
                <br/>
                <h3 className="home"> | full stack web developer</h3>
                PORTFOLIO
            </div>
            <br/>
            <div className="title">
            <div className="contactinfo">
                <h3 className="infoitem">(603) 459-5055</h3>
                <h3 className="infoitem">mhtreadwell718@gmail.com</h3>
                <a className="infolink" href="https://github.com/mollytreadwell"><h3 className="infolink">github</h3></a>
                <a className="infolink" href="https://vercel.com/dashboard"><h3 className="infolink">vercel</h3></a>
                <a className="infolink" href="https://www.instagram.com/molllyhoppy/"> <h3 className="infolink">instagram</h3></a>
                <a className="infolink" href="https://www.linkedin.com/in/molly-treadwell-a30693240/"><h3 className="infolink">linkedin</h3></a>
                </div>
                </div>
            </div>
        </div>
    )
}